import { echoAddress, upAddress, oauthRequestUrl } from "../config/config";
export const fileEcho = echoAddress; //文件上传回显
export const fileUp = upAddress; //文件上传
/*消息*/
export const messageList = "/sys/notices";//消息列表
export const messageRead = (id)=>{return "/sys/notices/"+id+"/mark-as-read"};//消息变为已读
export const messageAllRead = "/sys/notices/mark-as-read-all";//全部已读
/*商品管理*/
export const goodsNotReviewedList = "/sys/spu";//待审核列表
export const downList = (id)=>{return "/sys/spu/"+id+"/halt-sale"};//违规下架
export const goodeReviewedList = "/sys/spu/audited-list";//已审核商品列表
export const goodeReviewedList2 = "/sys/spu/floor-spu-list";//已审核商品列表
export const GoodsPass = (id)=>{return "/sys/spu/"+id+"/audit"};//审核商品
export const shopDetail = (id) => { return "/sys/store/"+id};//查询店铺详情
export const exportSpusFile = `/sys/spu/audited-list/excel`; // 导出商品列表
/*商品管理结束*/

/*作品管理*/
export const worksList = "/sys/works";//作品列表
export const worksTypeList = "/seller/proper-types/1";//获取作品类型
export const worksDetail = (id)=>{return "/sys/works/"+id};//作品详情
export const worksSubMit = (id)=>{return "/sys/works/"+id+ "/audit"};//作品详情
export const exportWorkFile = `/sys/works/excel`; // 导出作品列表

/*作品管理结束*/
/*分类管理*/
export const goodsTypeList = "/sys/proper-types";//商品类型管理
export const goodsTypeEdit = (id) =>{return "/sys/proper-types/"+id};//商品类型管理编辑
export const goodsTypeDetail = (id) =>{return "/sys/proper-types/"+id};//商品类型管理详情
export const goodsTypeDel = (id) =>{return "/sys/proper-types/"+id};//商品类型管理编辑
export const detailGood = (id)=>{return "/sys/spu/"+id};//商品详情
export const goodsClass = (id)=>{return "/sys/classifications/"+id};//商品类目
export const shopClassParent = (id) => { return "/sys/store-category/"+id };//店铺商品分类查询父级
export const addType = "/sys/proper-types";//新增商品类型
export const goodsTypeGroupingList = "/sys/attribute-templates";//获取商品属性模版列表
export const delGoodsTypeGroupingList = (id)=>{return "/sys/attribute-templates/"+id};//删除商品模版列表
export const editGoodsTypeGroupingList = (id)=>{return "/sys/attribute-templates/"+id};//修改商品模版列表
export const goodsTypeGroupingAdd = "/sys/attribute-templates";//新增商品属性模版列表
export const receptionClassList = "/sys/categories";//前台商品分类列表
export const receptionClassListSort = "/sys/categories/sort";//前台商品分类排序保存
export const addReceptionClassList = "/sys/categories";//新建前台商品分类
export const editReceptionClassList = (id)=>{return "/sys/categories/"+id};//编辑前台商品分类
export const delReceptionClassList = (id)=>{return "/sys/categories/"+id};//删除前台商品分类
export const searchReceptionClassList = (id)=>{return "/sys/categories/"+id};//查询前台商品分类闲情
//后台商品分类
export const goodsClassList = "/sys/classifications";//后台商品类目列表
export const goodsClassListUpload = "/sys/classifications/sort";//后台类目列表排序保存
export const editGoodsClassList = (id)=>{return "/sys/classifications/"+id };//编辑后台商品分类
export const addGoodsClassList = "/sys/classifications";//新增后台商品类目列表
export const delGoodsClassList = (id)=>{return "/sys/classifications/"+id};//删除后台商品类目列表
export const properTypes = "/sys/proper-types";//获取商品类型
export const priceList = "/sys/specification-template";//获取定价属性列表
export const addPrice = "/sys/specification-template";//新增定价属性
export const delPrice = (id)=>{ return "/sys/specification-template/"+id};//删除定价属性
export const editPrice = (id)=>{ return "/sys/specification-template/"+id};//编辑定价属性
export const goodsSeeList = "/sys/spu/get-by-classification";//查看关联商品
//前台分类管理
export const floorStyle = "/sys/floor-styles";//楼层样式
/*分类管理结束*/

/*系统设置*/
//角色管理
export const role = oauthRequestUrl+"/mall-admin/roles";//角色管理
export const cattalogs = oauthRequestUrl+'/mall-admin/resources/catalogs';//根据类型查询资源目录
//管理员管理
export const admins = oauthRequestUrl+"/mall-admin/admins";//管理员管理
export const subscriber = oauthRequestUrl+"/mall-admin/users"; //用户管理
//文章管理
export const articlesList = "/sys/article-category";//文章分类
export const articlesListAdd = "/sys/article-category";//新建文章分类
export const editclesList = (id)=>{return "/sys/article-category/"+id};//编辑保存
export const classDisable = (id)=>{return "/sys/article-category/"+id};//分类启禁用
export const delDisable = (id)=>{return "/sys/article-category/"+id};//分类删除
export const articlesDisable = (id)=>{return "/sys/articles/"+id+"/disable"};//禁用文章
export const articlesEnable = (id)=>{return "/sys/articles/"+id+"/enable"};//禁用文章
export const articlesDel = (id)=>{return "/sys/articles/"+id};//删除文章
export const articlesEdit = (id)=>{return "/sys/articles/"+id};//编辑文章
export const articlesEditSort = "/sys/article-category/sort";//文章排序保存
export const articlesSort = "/sys/articles/sort";//文章排序保存
export const articlesAdd = "/sys/articles";//新增文章内容
export const seeArticlesList = "/sys/articles";//查询文章内容
//系统日志
export const journalList = "/sys/logs";//系统操作日志
export const mallFloorList = "/sys/mall/floor";//商城楼层
//字典表
export const dictionaryList = "/sys/dictionaries";
//es重置
export const esList = "/sys/reset-es";//获取es列表
export const esReset = "/sys/reset-es/mall";//es重置
/*系统设置结束*/